/**
 * @param {String} url
 * @return {boolean}
 */
function isImageUrl(url) {
	return url.indexOf('.jpg') !== -1
		|| url.indexOf('.jpeg') !== -1
		|| url.indexOf('.png') !== -1;
}

export {isImageUrl};
